import { useEffect, useState } from 'react';

// The phone breakpoint the Organic layout switches at. Kept in step with
// the `@media (max-width: 767px)` blocks in organic.css and Chat.css —
// screens that restructure (rather than reflow) read it from here so the
// JS and the CSS can never disagree about what "mobile" means.
export const MOBILE_QUERY = '(max-width: 767px)';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (event) => setIsMobile(event.matches);
    // Re-read on mount: a rotation between render and effect would
    // otherwise leave the initial value stale until the next change.
    setIsMobile(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
